var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvestment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_1920_2729)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 35372",
    filter: "url(#filter0_d_1920_2729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.54209 31.4834H0.5625V49.4375H8.54209V31.4834Z",
    fill: "#005AA0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M35.4732 31.4834H27.4937V49.4375H35.4732V31.4834Z",
    fill: "#005AA0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.5064 41.458H14.5269V49.4376H22.5064V41.458Z",
    fill: "#D3AA29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M49.4376 16.5217H41.458V49.4375H49.4376V16.5217Z",
    fill: "#D3AA29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M0.570543 24.5123C1.28606 24.2627 1.99323 24.013 2.70318 23.7662C4.42656 23.1715 6.14993 22.5768 7.8733 21.9821C9.90014 21.2837 11.9214 20.574 13.9538 19.8895C14.9923 19.5417 15.9306 20.013 16.3315 21.0396C17.3254 23.5867 18.3193 26.1365 19.3133 28.6835C19.4998 29.166 19.6947 29.6428 19.9035 30.1674C19.9982 30.0832 20.0733 30.0243 20.1374 29.9542C20.6664 29.3792 21.1926 28.8013 21.7215 28.2263C25.3994 24.2122 29.0744 20.1981 32.7522 16.1868C34.9851 13.752 37.218 11.32 39.4536 8.888C39.6708 8.64957 39.8907 8.41394 40.1246 8.19234C40.3111 8.01842 40.2749 7.90622 40.0968 7.74633C39.0611 6.81784 38.0337 5.88095 36.998 4.94966C36.9312 4.88794 36.8338 4.8627 36.7502 4.82062C36.7725 4.78696 36.792 4.7561 36.8143 4.72244C41.0016 3.34234 45.1917 1.96224 49.4375 0.5625C48.5187 4.95527 47.6083 9.31157 46.6896 13.7071C45.4729 12.6103 44.2785 11.536 43.0702 10.4476C42.9867 10.5318 42.9199 10.5935 42.8586 10.6608C40.1218 13.6454 37.385 16.63 34.6454 19.6147C32.3903 22.0719 30.1324 24.532 27.8745 26.9892C25.6639 29.396 23.4533 31.8056 21.2399 34.2123C21.0283 34.4423 20.8056 34.6639 20.5884 34.8912C19.717 35.8084 18.2247 35.6177 17.6539 34.4872C17.3727 33.929 17.1667 33.3287 16.9384 32.7453C15.8275 29.9065 14.7167 27.0678 13.6197 24.2234C13.5306 23.9906 13.4193 23.9822 13.2244 24.0495C10.7771 24.8994 8.32711 25.7466 5.87987 26.5965C4.55463 27.0537 3.23217 27.511 1.90692 27.971C1.79277 28.0103 1.72317 28.0159 1.67584 27.8756C1.30834 26.7817 0.935263 25.6877 0.564975 24.5965C0.559407 24.5825 0.564975 24.5628 0.564975 24.5151L0.570543 24.5123Z",
    fill: "#005AA0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1920_2729",
    x: -3.4375,
    y: -1.4375,
    width: 56.875,
    height: 56.875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1920_2729"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1920_2729",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1920_2729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.875,
    height: 48.875,
    fill: "white",
    transform: "translate(0.5625 0.5625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestment);
export default __webpack_public_path__ + "static/media/investment.1bdb8f49f8b9bdce2cb8df2fbb19f968.svg";
export { ForwardRef as ReactComponent };